export const siteMeta = {
  name: "CELSZC",
  fullName: "Christ Embassy Lagos Sub Zone C",
  tagline:
    "To take the divine presence of God to the nations and peoples of the world; and to demonstrate the character of the Spirit.",
  vision:
    "To take the divine presence of God to the nations and peoples of the world; and to demonstrate the character of the Spirit.",
  mission:
    "To raise generations of men and women who will come into their inheritance to fulfill God's dream.",
  description:
    "Christ Embassy Lagos Sub Zone C (CELSZC) — join live services, watch messages, read news, and get involved in ministries across Lagos.",
  siteUrl: "https://celszc.org",
  ogImage: "/favicon.png",
  email: "info@celszc.org",
  phone: "+234 000 000 0000",
  address: "Lagos, Nigeria",
};

export const navLinks = [
  { label: "Home", href: "/" },
  {
    label: "About",
    href: "/about",
    children: [
      { label: "About Us", href: "/about" },
      { label: "Our Vision", href: "/vision" },
      { label: "Events", href: "/events" },
      { label: "Ministries", href: "/ministries" },
      { label: "Testimonies", href: "/testimonies" },
    ],
  },
  { label: "Live", href: "/live" },
  { label: "Messages", href: "/messages" },
  { label: "News", href: "/news" },
  { label: "Contact", href: "/contact" },
];

export const ministries = [
  {
    slug: "care-groups",
    title: "Care Groups",
    summary:
      "Join a cell of believers near you — grow spiritually, share life, and stay connected beyond Sunday.",
    body: "Our care groups help us locate you and walk with you. In a smaller fellowship you are known, prayed for, and equipped to live the Word daily. Find a group close to your home or workplace and take your next step in belonging.",
  },
  {
    slug: "foundation-school",
    title: "Foundation School",
    summary:
      "Learn the basic doctrines of Christ and build a strong spiritual foundation for life and ministry.",
    body: "Foundation School is where new believers and growing saints are taught the essentials of the Christian faith — salvation, the Holy Spirit, the Word, prayer, and victorious living. Complete the classes and step into greater purpose.",
  },
  {
    slug: "children",
    title: "Children's Church",
    summary:
      "A safe, joyful environment where children are taught God's Word and grow in the love of Christ.",
    body: "Children are precious. We create a secure and holistically spiritual environment where they encounter God's Word at their level — with worship, teaching, and care that plants lasting seeds of faith.",
  },
  {
    slug: "teens",
    title: "Teen's Church",
    summary:
      "Spiritual growth and leadership training designed for teenagers in CELSZC.",
    body: "Teen's Church caters to the spiritual needs of teenagers and trains them for leadership. Through teaching, fellowship, and service opportunities, teens discover identity in Christ and purpose for their generation.",
  },
  {
    slug: "youth",
    title: "Youth Church",
    summary:
      "For young adults stepping from teens into purpose, career, and Spirit-led living.",
    body: "When a teenager comes of age, there is a transition into adulthood. Youth Church walks with young adults through that season — Word, fellowship, and opportunities to serve in the vision.",
  },
  {
    slug: "water-baptism",
    title: "Water Baptism",
    summary:
      "Publicly identify with the death, burial, and resurrection of Jesus Christ.",
    body: "Water baptism is an ordinance of the church for every believer. Contact us to register for the next baptism service and celebrate this milestone with your local church family.",
  },
  {
    slug: "weddings",
    title: "Weddings & Counselling",
    summary:
      "Christ-centred preparation and celebration for couples building a godly home.",
    body: "We walk with couples through counselling, preparation, and wedding services that honour God. Reach out to schedule counselling or enquire about holding your ceremony with CELSZC.",
  },
  {
    slug: "baby-dedications",
    title: "Baby Dedications",
    summary:
      "Present your child to the Lord and commit to raising them in the nurture of the Word.",
    body: "Baby dedication is a joyful moment for parents and the church family. Register ahead of a service date so we can celebrate with you and pray over your child.",
  },
];

export const events = [
  {
    id: "sunday",
    title: "Sunday Service",
    cadence: "Every Sunday",
    time: "9:00 AM",
    blurb: "One service — worship, the Word, and fellowship across CELSZC churches.",
  },
  {
    id: "midweek",
    title: "Midweek Service",
    cadence: "Every Wednesday",
    time: "6:00 – 9:00 PM",
    blurb: "A midweek encounter to strengthen your walk with the Spirit.",
  },
  {
    id: "cell",
    title: "Cell / Care Group Meetings",
    cadence: "Weekly",
    time: "As scheduled by your cell",
    blurb: "Intimate fellowship and follow-up in your neighbourhood.",
  },
];

export const testimonies = [
  {
    name: "Sister A.O.",
    church: "CELSZC Church",
    excerpt:
      "Through consistent fellowship and the teaching of the Word in our zone, I experienced peace and direction in a season of uncertainty. The Lord ordered my steps.",
  },
  {
    name: "Brother T.K.",
    church: "CELSZC Church",
    excerpt:
      "Foundation School opened my eyes to who I am in Christ. I now serve with confidence, knowing I carry His Spirit and purpose.",
  },
  {
    name: "Sister M.E.",
    church: "CELSZC Church",
    excerpt:
      "Joining a care group changed everything. I found family, accountability, and a place to grow. Glory to God!",
  },
];

/** LoveWorld Inc. / Christ Embassy statement of faith */
export const statementOfFaith = {
  intro:
    "This is the statement of the Bible doctrine as believed and taught by LoveWorld Inc. aka Christ Embassy.",
  source:
    "This statement of faith has its source in the Bible and is in total agreement with the principles of the doctrines of Christ.",
  articles: [
    {
      text: "We believe that the Bible contains the inspired and infallible Word of God.",
      refs: "2 Timothy 3:16, 2 Peter 1:20-21",
    },
    {
      text: "We believe that there is only one God eternally existent in three persons; God the Father, God the Son and God the Holy Ghost.",
      refs: "Ephesians 4:5-6, Genesis 1:26, Matthew 3:16-17",
    },
    {
      text: "We believe in the deity of Christ.",
      refs: "John 1:1-4; John 10:30; Hebrews 1:1-5",
      points: [
        { text: "He was born of a virgin", refs: "Matthew 1:18-25; Luke 1:30-35" },
        { text: "He was conceived of the Holy Ghost", refs: "Matthew 1:18-25; Luke 1:30-35" },
        { text: "He died", refs: "John 19:30-35" },
        { text: "He rose again from the dead bodily", refs: "John 20:25-29; Luke 24:36-40" },
        { text: "He ascended into heaven bodily", refs: "1 Thessalonians 4:16-17; Matthew 24:29-30" },
      ],
    },
    {
      text: "We believe in the rapture of the church and the Second coming of Christ.",
      refs: "1 Thessalonians 4:16-17; Matthew 24:29-30",
    },
    {
      text: "We believe that the only means of being cleansed from sin is repentance and faith in the precious blood of Jesus.",
      refs: "Acts 3:19; Luke 24:47; Ephesians 1:7",
    },
    {
      text: "We believe regeneration by the power of the Holy Spirit through the Word of God is essential for personal salvation.",
      refs: "Titus 2:5; John 3:3-5; Ephesians 5:25-27",
    },
    {
      text: "We believe that the redemptive work of Christ on the cross provides divine healing for the body, salvation for the soul of everyone that believes.",
      refs: "1 Peter 2:24; Acts 3:16; Acts 9:32-35",
    },
    {
      text: "We believe that when an individual receives the Holy Ghost, he receives divine enablement for Christian service and witness.",
      refs: "Acts 1:8; 2:4; 3:1-26; 4:5-12",
    },
    {
      text: "We believe in the sanctifying power of the Holy Ghost.",
      refs: "Romans 15:16; 1 Corinthians 6:11",
    },
    {
      text: "We believe in the final resurrection of both the saved and the lost; the former to eternal life and the latter to eternal judgement.",
      refs: "Revelation 20:11-15; 1 Corinthians 15:12-23",
    },
  ],
};

/** Full-bleed worship imagery for hero planes */
export const heroImage =
  "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?auto=format&fit=crop&w=2400&q=80";
